import { Link } from "react-router-dom";
import { cn } from "../../../../utils/classnames";
import { TableEyeIcon } from "../../_components/Icons";

// Filter/table chrome now lives with the shared admin list components; these
// re-exports keep the existing import paths on this page working.
export { SearchIcon, ChevronDownIcon, SelectDropdownIndicator, SortIcon } from "../../_components/Icons";

const TREND_STYLES = {
  up: "tw:text-[#52BEB7]",
  down: "tw:text-[#F46956]",
  flat: "tw:text-[#F2BC2A]",
};

export const TrendIcon = ({ trend }) => (
  <div
    className={cn(
      "tw:h-[18px] tw:w-[18px] tw:rounded-full tw:border-[2px] tw:flex tw:items-center tw:justify-center",
      TREND_STYLES[trend] || TREND_STYLES.flat,
    )}
  >
    {trend === "flat" ? (
      <div className="tw:h-[2px] tw:w-[8px] tw:rounded-full tw:bg-current" />
    ) : (
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("tw:text-current", trend === "down" && "tw:rotate-180")}
        aria-hidden="true"
      >
        <path d="M4 1L6.8 3.8H5V7H3V3.8H1.2L4 1Z" fill="currentColor" />
      </svg>
    )}
  </div>
);

export const EyeButton = ({ id }) => (
  <Link
    to={`/admin/modification-requests/${id}`}
    className="tw:border-0 tw:bg-transparent tw:p-0"
    aria-label="View detail"
  >
    <span className="tw:flex tw:h-[30px] tw:w-[30px] tw:items-center tw:justify-center tw:rounded-[2px] tw:bg-[#D4B055]">
      <TableEyeIcon />
    </span>
  </Link>
);
